export default "__VITE_ASSET__224eb1c3__"